import { Charts } from '@shared/enums/charts.enum';
import { Questions } from '@shared/enums/questions.enum';
import { ChartSettings, DimensionDataItem } from '@shared/models/report.model';

export class ChartRecommendations {
  static chartTypes(scales: string[], details: DimensionDataItem[], comparison: any) {
    const suitableTypes: string[] = [];

    const linearNumber = (scales || []).filter((item) => item === 'linear').length;
    const categoricalNumber = (scales || []).filter((item) => item === 'categorical').length;
    const time = (scales || []).filter((item) => item === 'time').length;
    const text = (scales || []).filter((item) => item === 'text' || item === 'contact-text').length;
    const sentiment = (details || []).filter((item) => item.originalTypeSpecifier === 'text-sentiment').length;
    const words = (details || []).filter((item) => item.originalTypeSpecifier === 'text-words').length;
    const emotions = (details || []).filter((item) => item.originalTypeSpecifier === 'text-emotions').length;
    const aiInterviewer = (details || []).filter((item) => item.originalType === Questions.AI_INTERVIEWER).length;
    const whyFinder = (details || []).filter((item) => item.originalType === Questions.ESKO_WHY_FINDER).length;
    const responseRate = (details || []).filter((item) => item.originalType === 'response-rates').length;
    const sliders1ds = (details || []).filter((item) => item.originalType === Questions.SLIDER_1D).length;

    if (text > 0) {
      suitableTypes.push(Charts.TEXTANSWERTABLE);
    } else if (linearNumber > 0 && words === 0) {
      suitableTypes.push(Charts.BARCHARTV);
    } else if (categoricalNumber > 0 && words === 0 && responseRate === 0) {
      suitableTypes.push(Charts.PIECHART, Charts.DONUTCHART, Charts.MULTIDONUTCHART);
    }

    if (responseRate > 0) {
      suitableTypes.push(Charts.RESPONSERATES);
    }

    if (aiInterviewer > 3) {
      suitableTypes.push(Charts.INTERVIEWERSUMMARY);
    }

    if (whyFinder > 1) {
      suitableTypes.push(Charts.WHYFINDERSUMMARY);
    }

    if (linearNumber > 0) {
      suitableTypes.push(Charts.SUMMARY1D);
    }

    if (sliders1ds > 1) {
      suitableTypes.push(Charts.SUMMARYAVERAGES);
    }

    if (linearNumber === 1 && text === 0 && words === 0) {
      suitableTypes.push(Charts.NPS);
    }

    if (linearNumber > 1) {
      suitableTypes.push(Charts.SUMMARY2D);
    }

    if (categoricalNumber > 0 && text === 0 && words === 0 && responseRate === 0) {
      suitableTypes.push(Charts.BARCHARTH);
    }

    if (text > 0 && (sentiment > 0 || words > 0 || emotions > 0)) {
      suitableTypes.push(Charts.SMARTTEXTCHART);
    }

    if (
      emotions === 1 &&
      text === 1 &&
      (categoricalNumber === 1 ||
        (categoricalNumber === 2 && comparison && comparison.values && comparison.values.length)) &&
      words === 0
    ) {
      suitableTypes.push(Charts.TEXTEMOTIONS);
    }

    // if (
    //   (categoricalNumber === 1 ||
    //     (categoricalNumber === 2 && comparison && comparison.values && comparison.values.length)) &&
    //   text === 1 &&
    //   linearNumber === 0
    // ) {
    //   suitableTypes.push(Charts.BARCHARTHPLUSTEXT);
    // }

    // We hide word cloud from recommendations and we recommend word analysis instead
    // if (text > 0 || categoricalNumber > 0) {
    //   suitableTypes.push(Charts.WORDCLOUD);
    // }

    if (
      sentiment === 1 &&
      text === 1 &&
      (categoricalNumber === 0 ||
        (categoricalNumber === 1 && comparison && comparison.values && comparison.values.length)) &&
      linearNumber === 1 &&
      words === 0
    ) {
      suitableTypes.push(Charts.TEXTSENTIMENTANALYSIS);
    }

    if (
      words > 0 &&
      sentiment === 0 &&
      (categoricalNumber < 2 ||
        (categoricalNumber === 2 && comparison && comparison.values && comparison.values.length)) &&
      linearNumber === 0 &&
      text === 0 &&
      time === 0
    ) {
      suitableTypes.push(Charts.WORDANALYSIS);
    } else if (words > 0) {
      suitableTypes.push(Charts.TEXTANSWERTABLE);
    }

    if (
      !(categoricalNumber > 0 && linearNumber < 3 && linearNumber > 0) &&
      !(categoricalNumber === 1 && linearNumber === 0 && text > 0) &&
      (categoricalNumber > 0 || linearNumber > 2) &&
      !(categoricalNumber > 0 && text > 0) &&
      words === 0 &&
      responseRate === 0
    ) {
      suitableTypes.push(Charts.RADARCHART);
    }

    if (time > 0 && words === 0 && emotions === 0) {
      if (text === 0) {
        suitableTypes.push(Charts.BARCHARTV, Charts.LINECHART);
      }

      if ((scales || []).length <= 2 && scales[0] === 'time' && text === 0) {
        suitableTypes.push(Charts.TIMELINECHART);
      }

      if (categoricalNumber > 0) {
        suitableTypes.push(Charts.MULTILINECHART);
        suitableTypes.push(Charts.TRENDCATEGORICALCHART);
      }
      if (linearNumber > 0) {
        suitableTypes.push(Charts.TRENDLINEAR1DCHART);

        if (linearNumber === 1) {
          suitableTypes.push(Charts.TRENDNPSCHART);
        }

        if (linearNumber > 1) {
          suitableTypes.push(Charts.TRENDLINEAR2DCHART);
        }
      }
    }

    if ((scales || []).length === 2 && words === 0) {
      if (categoricalNumber === 2) {
        suitableTypes.push(
          Charts.STACKEDBARCHARTH,
          Charts.STACKEDBARCHARTV,
          Charts.MULTIBARCHARTH,
          Charts.MULTIBARCHARTV,
        );
      } else if (linearNumber === 2) {
        suitableTypes.push(Charts.HEATMAP);
      } else if (linearNumber === 1 && categoricalNumber === 1) {
        suitableTypes.push(
          Charts.STACKEDBARCHARTH,
          Charts.STACKEDBARCHARTV,
          Charts.MULTIBARCHARTH,
          Charts.MULTIBARCHARTV,
        );
      }
    }

    if ((scales || []).length === 3) {
      if (categoricalNumber === 1 && linearNumber === 2) {
        suitableTypes.push(Charts.HEATMAP);
      }
    }

    if (((categoricalNumber > 1 && !comparison) || categoricalNumber > 2) && words === 0) {
      suitableTypes.push(Charts.SUMMARYCHOICE);
    }

    return suitableTypes;
  }

  static chartType(scales: string[], details: DimensionDataItem[]) {
    const linearNumber = (scales || []).filter((item) => item === 'linear').length;
    const categoricalNumber = (scales || []).filter((item) => item === 'categorical').length;
    const time = (scales || []).filter((item) => item === 'time').length;
    const textNumber = (scales || []).filter((item) => item === 'text' || item === 'contact-text').length;
    const nps = (details || []).filter((item) => Questions.isNps({ type: item.originalType as Questions })).length;
    const sentiment = (details || []).filter((item) => item.originalTypeSpecifier === 'text-sentiment').length;
    const words = (details || []).filter((item) => item.originalTypeSpecifier === 'text-words').length;
    const emotions = (details || []).filter((item) => item.originalTypeSpecifier === 'text-emotions').length;
    const userSegments = (details || []).filter((item) => item.originalType === 'userSegments').length;
    const aiInterviewer = (details || []).filter((item) => item.originalType === Questions.AI_INTERVIEWER).length;
    const whyFinder = (details || []).filter((item) => item.originalType === Questions.ESKO_WHY_FINDER).length;
    const responseRates = (details || []).filter((item) => item.originalType === 'response-rates').length;

    if ((scales || []).length === 1) {
      if (nps > 0) {
        return Charts.NPS;
      } else if (words > 0) {
        return Charts.WORDANALYSIS;
      } else if (responseRates > 0) {
        return Charts.RESPONSERATES;
      } else if (categoricalNumber > 0) {
        return Charts.BARCHARTH;
      } else if (linearNumber > 0) {
        return Charts.BARCHARTV;
      } else if (time > 0) {
        return Charts.TIMELINECHART;
      } else if (textNumber > 0) {
        return Charts.TEXTANSWERTABLE;
      } else {
        return '';
      }
    } else if ((scales || []).length === 2) {
      if (categoricalNumber === 2 && words === 0) {
        return Charts.STACKEDBARCHARTH;
      } else if (linearNumber === 2) {
        return Charts.HEATMAP;
      } else if (nps === 1) {
        return Charts.NPS;
      } else if (time > 0) {
        return Charts.BARCHARTH;
      } else if (emotions === 1 && textNumber === 1) {
        return Charts.SMARTTEXTCHART;
      } else if (sentiment === 1 && textNumber === 1) {
        return Charts.TEXTSENTIMENTANALYSIS;
      } else if (textNumber > 0) {
        return Charts.TEXTANSWERTABLE;
      } else {
        return Charts.SUMMARY1D;
      }
    } else if ((scales || []).length > 2) {
      if (aiInterviewer > 3) {
        return Charts.INTERVIEWERSUMMARY;
      } else if (whyFinder > 1) {
        return Charts.WHYFINDERSUMMARY;
      } else if ((emotions === 1 || sentiment === 1 || words === 1) && textNumber === 1) {
        return Charts.SMARTTEXTCHART;
      } else if (
        linearNumber > 3 &&
        details.length > 3 &&
        details.filter((item) => item.originalType === Questions.SLIDER_2D).length > 3
      ) {
        return Charts.SUMMARY2D;
      } else if (linearNumber > 0) {
        return Charts.SUMMARY1D;
      } else if (categoricalNumber / scales.length > 0.7 && words === 0) {
        return Charts.SUMMARYCHOICE;
      } else if (
        emotions === 1 &&
        textNumber === 1 &&
        (categoricalNumber === 1 || (categoricalNumber === 2 && userSegments === 1)) &&
        words === 0
      ) {
        return Charts.TEXTEMOTIONS;
      } else if (textNumber > 0) {
        return Charts.TEXTANSWERTABLE;
      } else {
        return Charts.BARCHARTH;
      }
    } else {
      return '';
    }
  }

  static comparisonChart(scales, originalType) {
    if ((scales || []).length === 2) {
      if (originalType === Charts.NPS) {
        return Charts.NPS;
      } else if (originalType === Charts.SMARTTEXTCHART) {
        return Charts.SMARTTEXTCHART;
      } else if (scales[0] === 'categorical') {
        return Charts.MULTIBARCHARTH;
      } else if (scales[0] === 'linear') {
        return Charts.MULTIBARCHARTV;
      } else if (scales[0] === 'text' || scales[0] === 'contact-text') {
        return Charts.TEXTANSWERTABLE;
      } else if (scales[0] === 'time') {
        return Charts.TIMELINECHART;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  static trendChart(details, originalType) {
    if (originalType === Charts.NPS) {
      return Charts.TRENDNPSCHART;
    } else if (originalType === Charts.BARCHARTHPLUSTEXT) {
      return Charts.BARCHARTHPLUSTEXT;
    } else if (originalType === Charts.TEXTEMOTIONS) {
      return Charts.TEXTEMOTIONS;
    } else if (originalType === Charts.INTERVIEWERSUMMARY) {
      return Charts.INTERVIEWERSUMMARY;
    } else if (originalType === Charts.WHYFINDERSUMMARY) {
      return Charts.WHYFINDERSUMMARY;
    } else if (originalType === Charts.RESPONSERATES) {
      return Charts.RESPONSERATES;
    } else if (originalType === Charts.SMARTTEXTCHART) {
      return Charts.SMARTTEXTCHART;
    } else if (originalType === Charts.SUMMARYAVERAGES) {
      return Charts.SUMMARYAVERAGES;
    } else if ((details || []).length === 2) {
      if (details[1]['originalTypeSpecifier'] === 'text-words') {
        return Charts.TEXTANSWERTABLE;
      } else if (details[1]['scale'] === 'categorical') {
        return Charts.TRENDCATEGORICALCHART;
      } else if (details[1]['scale'] === 'linear') {
        return Charts.TRENDLINEAR1DCHART;
      } else if (details[1]['scale'] === 'text' || details[1]['scale'] === 'contact-text') {
        return Charts.TEXTANSWERTABLE;
      } else {
        return '';
      }
    } else if ((details || []).length === 3) {
      if (details.filter((item) => item['originalTypeSpecifier'] === 'text-words').length > 0) {
        return Charts.TEXTANSWERTABLE;
      } else if (originalType === Charts.HEATMAP) {
        return Charts.TRENDLINEAR2DCHART;
      } else if (details.filter((item) => item && item.scale === 'categorical').length === 2) {
        return Charts.TRENDCATEGORICALCHART;
      } else if (
        details.filter((item) => item && item.scale === 'categorical').length === 1 &&
        details.filter((item) => item && item.scale === 'linear').length === 1
      ) {
        return Charts.TRENDLINEAR1DCHART;
      } else if (originalType === Charts.SUMMARY1D) {
        return Charts.TRENDLINEAR1DCHART;
      } else if (details.find((item) => item && item.originalTypeSpecifier === 'text-sentiment')) {
        return Charts.TEXTSENTIMENTANALYSIS;
      } else {
        return '';
      }
    } else if ((details || []).length > 3) {
      if (originalType === Charts.SUMMARY1D) {
        return Charts.TRENDLINEAR1DCHART;
      } else if (originalType === Charts.SUMMARY2D || originalType === Charts.HEATMAP) {
        return Charts.TRENDLINEAR2DCHART;
      } else if (details.find((item) => item && item.originalTypeSpecifier === 'text-sentiment')) {
        return Charts.TEXTSENTIMENTANALYSIS;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  static chartHeight(
    data: any,
    type: string,
    comparison: any = null,
    chartSettings: ChartSettings = {} as ChartSettings,
    notes?: string,
  ) {
    let chartCount = 0;
    let newSize = 0;

    if (type === Charts.SUMMARY2D) {
      chartCount += 1;

      if (comparison && comparison.values && comparison.values.length > 0) {
        if (!chartSettings || chartSettings.summaryChartComparisonMode !== 'joined') {
          chartCount = comparison.values.length;
        }
      }

      const groups = new Set();

      for (let d = 0, lend = ((data && data.details) || []).length; d < lend; d++) {
        if (data.details[d]?.originalType === 'slider-2d') {
          const groupId = `${data.details[d].labelsLinear?.axis || ''}: ${data.details[d].labelsLinear?.min || ''} - ${
            data.details[d].labelsLinear?.max || ''
          } (${data.details[d].valueScaleLinear?.min}-${data.details[d].valueScaleLinear?.max})`;
          groups.add(groupId);
        }
      }

      if (Math.floor(groups.size / 2) > 1) {
        chartCount = Math.floor(groups.size / 2) * chartCount;
      }

      newSize = 8 + (chartCount > 1 ? (chartCount - 1) * 4 : 0);
    } else if (type === Charts.SUMMARY1D) {
      chartCount += 1;

      if (comparison && comparison.values && comparison.values.length > 0) {
        if (!chartSettings || chartSettings.summaryChartComparisonMode !== 'joined') {
          chartCount = comparison.values.length;
        }
      }
      const groupSizes: { [id: string]: number } = {};
      const questionGroups: { [id: string]: any } = {};

      for (let i = 0, len = (data.details || []).length; i < len; i++) {
        const detail = data.details[i];
        if (detail?.scale === 'linear') {
          const groupId = `${detail?.labelsLinear?.axis || ''}: ${detail?.labelsLinear?.min || ''} - ${
            detail?.labelsLinear?.max || ''
          } (${detail?.valueScaleLinear?.min}-${detail?.valueScaleLinear?.max})`;

          if (!groupSizes[groupId]) {
            groupSizes[groupId] = 0;
            questionGroups[groupId] = new Set();
          }
          groupSizes[groupId] += 1;
          if (detail.group) {
            questionGroups[groupId].add(detail.group);
          }
        }
      }

      for (const qg in questionGroups) {
        if (questionGroups[qg].size) {
          groupSizes[qg] += questionGroups[qg].size;
        }
      }

      newSize = Object.values(groupSizes).reduce(
        (a: number, b: number) =>
          a +
          1 +
          chartCount * Math.round(b / 2) +
          (b > 2 ? 1 + Math.round(b / 8) : 0) +
          (window.innerWidth > 1400 && b > 2 ? Math.ceil(b / 4) : 0),
        2 + (window.innerWidth > 1400 && Object.keys(groupSizes).length > 1 ? 1 : 0),
      );
      newSize = newSize < 5 ? 5 : newSize;
    } else if (type === Charts.BARCHARTH || type === Charts.STACKEDBARCHARTH) {
      chartCount += (data.details || []).length;
      const legendSpace =
        (comparison && comparison.values && comparison.values.length && Math.ceil(comparison.values.length / 3)) || 0;
      let barCount = 0;
      let choicePicture = false;

      for (let i = 0, len = data.scales.length; i < len; i++) {
        if (type !== Charts.STACKEDBARCHARTH || i === 0) {
          if (data.scales[i] === 'linear') {
            barCount += 11; // proper scaling needed here!
          } else {
            barCount += (data.details && data.details[i] && data.details[i]['values'].length) || 0;
          }
          if (data.details[i] && data.details[i]['originalType'] === Questions.CHOICE_PICTURE) {
            choicePicture = true;
          }
        }
      }
      const barCountAddition: number = Math.round(
        choicePicture
          ? barCount
          : barCount > 1
            ? ((barCount - 1) * ((barCount % 2 === 0 ? barCount - 2 : barCount - 1) / 2)) / (barCount - 1)
            : 0,
      );
      newSize = chartCount * 3 + (barCountAddition < 5 ? barCountAddition : 5) + (choicePicture ? 1 : 2) + legendSpace;
    } else if (type === Charts.MULTIBARCHARTH) {
      const legendSpace =
        (comparison && comparison.values && comparison.values.length && Math.ceil(comparison.values.length / 3)) || 0;
      const barCount: number =
        data.scales[0] === 'linear'
          ? 11
          : data.distributions && data.distributions[0]
            ? Object.keys(data.distributions[0]).length
            : 0;
      const barMultiplier: number =
        data.scales[1] === 'linear'
          ? 11
          : data.comparison != null && data.comparison.index === 1 && data.comparison.values
            ? data.comparison.values.length || 1
            : data.distributions && data.distributions[1]
              ? Object.keys(data.distributions[1]).length
              : 1;

      newSize =
        Math.min(Math.round(barCount / 6 + Math.round(Math.ceil(barMultiplier + barCount / 6) / 2 || 1)) + 2 + 3, 8) +
        legendSpace;
    } else if (type === Charts.BARCHARTV || type === Charts.LINECHART || type === Charts.AREACHART) {
      chartCount += (data.details || []).length;
      newSize = Math.round(chartCount * 2.5) + 2;
    } else if (type === Charts.PIECHART || type === Charts.DONUTCHART) {
      chartCount += (data.details || []).length;
      newSize = chartCount * 3 + 3;
    } else if (type === Charts.MULTIDONUTCHART) {
      chartCount += (data.details || []).length;
      let donutCount = 0;
      for (const i in data.scales) {
        if (data.scales[i] === 'linear') {
          donutCount += 11; // proper scaling needed here!
        } else {
          donutCount += Object.keys(data.distributions && data.distributions[i]).length;
        }
      }
      newSize = chartCount * 3 + Math.round(donutCount / 2) + 3;
    } else if (type === Charts.TEXTANSWERTABLE) {
      newSize = 6 + (chartSettings?.textSummary ? 3 : 0);
    } else if (type === Charts.TEXTSENTIMENTANALYSIS) {
      newSize = 11;
    } else if (type === Charts.TEXTEMOTIONS) {
      newSize =
        11 +
        (comparison && comparison.values && comparison.values.length > 0
          ? (comparison.values.length - 1) * (data.trend ? 6 : 3)
          : 0);
    } else if (type === Charts.INTERVIEWERSUMMARY) {
      newSize =
        11 +
        (comparison && comparison.values && comparison.values.length > 0
          ? (comparison.values.length - 1) * (data.trend ? 6 : 3)
          : 0);
    } else if (type === Charts.WHYFINDERSUMMARY) {
      newSize = 9;
    } else if (type === Charts.BARCHARTHPLUSTEXT) {
      newSize =
        11 +
        (comparison && comparison.values && comparison.values.length > 0
          ? (comparison.values.length - 1) * (data.trend ? 7 : 1)
          : 0);
    } else if (type === Charts.WORDANALYSIS) {
      newSize =
        11 +
        (comparison && comparison.values && comparison.values.length > 0
          ? Math.floor((comparison.values.length - 1) / 2) * 7
          : 0);
    } else if (type === Charts.NPS) {
      chartCount += 1;
      if (comparison && comparison.values && comparison.values.length > 0) {
        chartCount = comparison.values.length;
      } else {
        for (const i in data.scales) {
          if (data.scales[i] === 'categorical' || (data.scales[i] === 'time' && data.stats[i])) {
            chartCount += data.details?.[i]?.values?.length;
          }
        }
      }
      newSize = Math.floor(chartCount / 3) + 5 + (chartCount > 4 ? 1 : 0);
    } else if (type === Charts.HEATMAP) {
      if (data.distributions && data.distributions.length > 2) {
        const catIndex = data.details.findIndex((d) => d.scale === 'categorical');
        chartCount += catIndex >= 0 && data.distributions[catIndex] ? data.distributions[catIndex].length : 0;
      }
      newSize = chartCount === 0 ? 6 : chartCount * 4 + 2;
    } else if (type === Charts.RADARCHART) {
      const parseGroupId = (details) =>
        `${details.labelsLinear?.axis || ''}: ${details.labelsLinear?.min || ''} - ${
          details.labelsLinear?.max || ''
        } ` + `(${details.valueScaleLinear.min}-${details.valueScaleLinear.max})`;

      const parseGroupNumber = (details) => {
        const groups = {};
        for (const item in details) {
          if (details[item].scale === 'linear') {
            const groupId = parseGroupId(details[item]);
            groups[groupId] = 'exists';
          }
        }

        return Object.keys(groups).length;
      };

      let linearNumber = 0;
      // let categoricalNumber = 0;

      for (const i in data.scales) {
        if (data.scales[i] === 'linear') {
          linearNumber += 1;
        } else if (data.scales[i] === 'categorical') {
          // categoricalNumber += 1;
        }
      }

      if (linearNumber > 2) {
        chartCount = parseGroupNumber(data.details);
      } else {
        const len = data.distributions && data.distributions.length;
        chartCount = comparison ? len - 1 : len;
      }

      newSize = chartCount * 4 + 2;
    } else if (type === Charts.TRENDLINEAR2DCHART) {
      chartCount += 1;

      if (comparison && comparison.values && comparison.values.length > 0) {
        if (!chartSettings || chartSettings.summaryChartComparisonMode !== 'joined') {
          chartCount = comparison.values.length;
        }
      }

      const groups = new Set();

      for (let d = 0, lend = ((data && data.details) || []).length; d < lend; d++) {
        if (data.details[d] && data.details[d].originalType === 'slider-2d') {
          const groupId = `${data.details[d].labelsLinear?.axis || ''}: ${data.details[d].labelsLinear?.min || ''} - ${
            data.details[d].labelsLinear?.max || ''
          } (${data.details[d].valueScaleLinear?.min}-${data.details[d].valueScaleLinear?.max})`;
          groups.add(groupId);
        }
      }

      if (Math.floor(groups.size / 2) > 1) {
        chartCount = Math.floor(groups.size / 2) * chartCount;
      }

      newSize = 8 + (chartCount > 1 ? (chartCount - 1) * 5 : 0);
    } else if (type === Charts.TRENDLINEAR1DCHART) {
      chartCount += 1;
      if (comparison && comparison.values && comparison.values.length > 0) {
        if (!chartSettings || chartSettings.summaryChartComparisonMode !== 'joined') {
          chartCount = comparison.values.length;
        }
      }
      const groups = new Set();
      let linearCount = 0;

      for (let i = 0, len = (data.details || []).length; i < len; i++) {
        const detail = data.details[i];
        if (detail.scale === 'linear') {
          linearCount += 1;
          groups.add(
            `${detail.labelsLinear ? detail.labelsLinear.axis : ''}: ${
              detail.labelsLinear ? detail.labelsLinear.min : ''
            } - ${detail.labelsLinear ? detail.labelsLinear.max : ''} (${detail.valueScaleLinear.min}-${
              detail.valueScaleLinear.max
            })`,
          );
        }
      }

      newSize = groups.size * chartCount * (4 + Math.round(linearCount / 10)) + 2;
    } else if (type === Charts.TRENDCATEGORICALCHART || type === Charts.TRENDNPSCHART) {
      chartCount += 1;
      if (comparison && comparison.values && comparison.values.length > 0) {
        chartCount = comparison.values.length;
      }

      newSize = chartCount * 4 + 2;
    } else if (type === Charts.TIMELINECHART) {
      newSize = 5;
    } else if (type === Charts.SUMMARYCHOICE) {
      newSize = Math.max(data?.details?.length * (comparison?.values?.length || 1), 6);
    } else if (type === Charts.SUMMARYAVERAGES) {
      if (comparison && comparison.values && comparison.values.length > 0) {
        chartCount = comparison.values.length;
      }

      newSize = Math.ceil(chartCount / 3) + 7;
    } else if (type === Charts.RESPONSERATES) {
      const index = data?.details?.findIndex((item) => item?.originalType === 'response-rates');
      const shares = data?.details?.[index]?.values?.length || 0;

      newSize = 6 + Math.round(shares / 20);
    } else if (type === Charts.SMARTTEXTCHART) {
      const subType = chartSettings.smartTextChartMode;

      if (subType === Charts.TEXTSENTIMENTANALYSIS) {
        newSize = 11;
      } else if (subType === Charts.TEXTEMOTIONS) {
        newSize =
          11 +
          (comparison && comparison.values && comparison.values.length > 0
            ? (comparison.values.length - 1) * (data.trend ? 5 : 3)
            : 0);
      } else if (subType === Charts.WORDANALYSIS) {
        newSize =
          11 +
          (comparison && comparison.values && comparison.values.length > 0
            ? Math.floor((comparison.values.length - 1) / 2) * 7
            : 0);
      } else {
        newSize = 7 + (chartSettings?.textSummary ? 3 : 0);
      }
    } else if (!type) {
      newSize = 1;
    } else {
      newSize = 6;
    }

    if (data?.notes || data?.description || notes) {
      newSize += 2;
    }

    return newSize;
  }

  static getInteractionTips(type: string, comparison?: boolean) {
    if ([Charts.SUMMARY1D, Charts.SUMMARY2D].includes(type)) {
      return (
        'Use Intelligent Zoom to to see the differences between the items. ' +
        'Click items to highlight them in the chart.'
      );
    } else if (type === Charts.WHYFINDERSUMMARY) {
      return 'Hover themes to learn more and try clicking them to select items for deeper inspection or comparison';
    } else if (type === Charts.SUMMARYCHOICE) {
      return 'Try clicking the chart to select items for deeper inspection or to compare them';
    } else if (type === Charts.NPS) {
      return comparison
        ? 'Expand chart to see more columns. Sort the table using headers.'
        : 'Try clicking the chart to select items for comparison';
    } else if ([Charts.BARCHARTH, Charts.STACKEDBARCHARTH, Charts.MULTIBARCHARTH].includes(type)) {
      return 'Try clicking the bars to select items for deeper inspection or to compare them';
    } else if ([Charts.BARCHARTV, Charts.STACKEDBARCHARTV, Charts.MULTIBARCHARTV].includes(type)) {
      return 'Try swiping the bars to select areas for deeper inspection or to compare them';
    } else if (type === Charts.TIMELINECHART) {
      return 'Try swiping the timeline to select time period for deeper inspection or to compare them';
    } else if (type === Charts.SMARTTEXTCHART) {
      return 'Try clicking icons to see the sentiment analysis or word clouds.';
    } else {
      return '';
    }
  }
}
